import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import ReportStages from "../ReportStages";
import { useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { useNavigate } from "react-router-dom";
import { encryptToken } from "../../Services/Account/EncryptionParams";


const ReportStagesPage = () => {
    const navigate=useNavigate()
    const [PopupComponentEditStatus, setPopupComponentEditStatus] =
        useState(false);
    const [applicationInformationGuid,setApplicationInformationGuid]=useState(null)
    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];

    const RequestAccessor = [
        {
            KeyName: "stagesName",
            ShowStatus: true,
            NmaeColumn: "المرحلة الحالية",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "applicationNumber",
            ShowStatus: true,
            NmaeColumn: "رقم الطلب",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "dateCreate",
            ShowStatus: true,
            NmaeColumn: "تاريخ تقديم الطلب",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "currentStageStatus",
            ShowStatus: true,
            NmaeColumn: "حالة المرحلة الحالية",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
    ];

    

    const OtherMainBtns = [
        {
            Click: async (e) => {
                setApplicationInformationGuid(e.target.value)
                closePopupEditComponent()
            },
            content: "",
            className: "bi bi-view-list",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        },
        {
            Click: async (e) => {
                let token = encryptToken(e.target.value);
                navigate(`/grants/manager/PrepareProgressReport/${token}`)
            },
            content: "",
            className: "bi bi-sliders",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
            PrepareProgressReport:true
        },

        // {
        //     Click: async (e) => {
                
        //        navigate(`/grants/ReportStageContainer/${encryptToken(e.target.value)}`);
        //     },
        //     content: "",
        //     className: "bi bi-sliders",
        //     id: "editBtn",
        //     title: "عرض",
        //     ShowStatus: true,
        //     PrepareProgressReport:true
        // }
    ];
    const PopupOPjectData = {
        isPopupOpenStatus: true,
        isPopupOpenFunction: () => { },
        componentBody: <></>,
        maxWidth: "700px",
        maxHeight: "800px",
        title: "الأهداف",
    };

    const closePopupEditComponent = () => {
        if (PopupComponentEditStatus) {
            setPopupComponentEditStatus(false);
        } else {
            setPopupComponentEditStatus(true);
        }
    };
    return (
        <>
            <SharedDiv
                showTitle={true}
                titleName={state.jsonData ? state.jsonData.RS_Report.nameAR : ""} // Display the translated title of the time frame information
                child={[<TableAHSF
                    culomEdite={culomEdite}
                    uniqueValue={"aI_ApplicationInformationId"}
                    valueButtonAction={"aI_ApplicationInformationId"}
                    URL={`api/PR_Reports/GetAllRports`}
                    // UrlBody={{
                    //     aI_ApplicationInformationId: "",
                    // }}
                    staticKeyEdite={staticKeyEdite}
                    accessor={RequestAccessor}
                    titelTable={""}
                    selectRowNumber={true}
                    checkBoksColumName="اختيار"
                    sort={true}
                    pagination={true}
                    AppStatus={true}
                    // tableBtn={!shouldDisableFields}
                    sortTable={true}
                    keyNameSort={"dateCreate"}
                    dateKey="dateCreate"
                    dateformat="DD/MM/YYYY h:mm a"
                    arrayNameSort={["applicationNumber"]}
                    search={true}
                    openPopupState={false}
                    DropdownArrayFiltration={[]}
                    DropdownFiltration={false}
                    exportData={true}
                    checkBoks={false}
                    nameColumAction=""
                    total={false}
                    arrayButton={OtherMainBtns}
                    ArrayNameDataColum={RequestsColumns}
                    columnKeyNameArray={[
                        { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                    ]}
                    PopupOPjectData={PopupOPjectData}
                    popUpTitle={"معلومات الطلب"}
                />]} // Display the TimeFrameInformation component
                showButton={true}
                id_Title="PrepareProgressReport"
            />


            <PopupAHSF
                title={"المراحل"}
                componentBody={
                    <ReportStages applicationInformationGuid={applicationInformationGuid} view={true} />
                }
                maxWidth="1000px"
                maxHeight="1200px"
                isPopupOpenStatus={PopupComponentEditStatus}
                isPopupOpenFunction={closePopupEditComponent}
            />



        </>
    )
}
export default ReportStagesPage